import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_add_warehouses",
  ref: "addWarehouses",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_add_merchant_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_9 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_add_pos_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_add_pos_header",
  "data-kt-scroll-wrappers": "#kt_modal_add_pos_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "form-group d-flex flex-wrap" }
const _hoisted_13 = { class: "col-form-label required fw-bold fs-6" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "form-group mb-7" }
const _hoisted_16 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = { class: "form-group mb-7" }
const _hoisted_20 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_21 = { class: "col-md-6" }
const _hoisted_22 = { class: "form-group mb-7" }
const _hoisted_23 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-md-6" }
const _hoisted_26 = { class: "form-group mb-7" }
const _hoisted_27 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_28 = { class: "col-md-6" }
const _hoisted_29 = { class: "form-group mb-7" }
const _hoisted_30 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_31 = { class: "modal-footer flex-center" }
const _hoisted_32 = { class: "svg-icon svg-icon-3 ms-0 me-2" }
const _hoisted_33 = {
  ref: "submitButton",
  type: "submit",
  class: "btn btn-lg btn-primary"
}
const _hoisted_34 = { class: "indicator-label" }
const _hoisted_35 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_36 = { class: "indicator-progress" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.t("common.add")) + _toDisplayString(_ctx.t("common.warehouse")), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createVNode(_component_el_form, {
          onSubmit: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.t("warehouse.status")), 1),
                      _createVNode(_component_el_form_item, { prop: "status" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_switch, {
                            modelValue: _ctx.formData.status,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.status) = $event)),
                            "active-value": 10,
                            "inactive-value": 25
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.t("warehouse.shortKey")), 1),
                      _createVNode(_component_el_form_item, { prop: "code" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.code,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.code) = $event)),
                            type: "text",
                            placeholder: _ctx.t('common.plsEnter'),
                            clearable: ""
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.t("warehouse.shortCode")), 1),
                      _createVNode(_component_el_form_item, { prop: "short_code" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.short_code,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.short_code) = $event)),
                            type: "text",
                            placeholder: _ctx.t('common.plsEnter'),
                            clearable: ""
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.t("warehouse.name")), 1),
                      _createVNode(_component_el_form_item, { prop: "name" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.name,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.name) = $event)),
                            type: "text",
                            placeholder: _ctx.t('common.plsEnter'),
                            clearable: ""
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.t("warehouse.type")), 1),
                      _createVNode(_component_el_form_item, { prop: "type" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.formData.type,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.type) = $event)),
                            clearable: "",
                            placeholder: _ctx.t('common.plsSelect'),
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.type, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.t("warehouse.functionType")), 1),
                      _createVNode(_component_el_form_item, { prop: "function_type" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.formData.function_type,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.function_type) = $event)),
                            clearable: "",
                            placeholder: _ctx.t('common.plsSelect'),
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.function_type, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("button", {
                type: "reset",
                class: "btn btn-light me-3",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleDiscard && _ctx.handleDiscard(...args)))
              }, [
                _createElementVNode("span", _hoisted_32, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.t("common.discard")), 1)
              ]),
              _createElementVNode("button", _hoisted_33, [
                _createElementVNode("span", _hoisted_34, [
                  _createElementVNode("span", _hoisted_35, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.t("common.submit")), 1)
                ]),
                _createElementVNode("span", _hoisted_36, [
                  _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                  _hoisted_37
                ])
              ], 512)
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}